import { Product } from "./types";

/**
 * Pick the Advanced blood test product (sole active blood-only package).
 *
 * Lives in its own module rather than beside the component that renders it:
 * bookingFlowStore needs it for the ?packageType=membership entry, and importing
 * BloodTrackingLayout from the store closes an import cycle
 * (store → BloodTrackingLayout → BloodTrackingCards → ProductUSPs → useMarket →
 * store) that leaves exports undefined at bundle init and breaks the product
 * step at runtime — invisible to tsc, caught only by e2e.
 */
export function pickBaselineProduct(products: Product[]): Product | null {
  const candidates = products.filter(
    (p) =>
      p.product_type === "package" &&
      p.status === "active" &&
      // Backward-compat: products with no package_types show for all types
      (!p.package_types?.length || p.package_types.includes("blood-only")),
  );
  // Prefer sort_order, then display_order, then alphabetical — same rules
  // PackageList applies so we land on the same canonical product.
  candidates.sort((a, b) => {
    if (a.sort_order !== undefined && b.sort_order !== undefined) {
      return a.sort_order - b.sort_order;
    }
    if (a.display_order !== undefined && b.display_order !== undefined) {
      return a.display_order - b.display_order;
    }
    return a.name.localeCompare(b.name);
  });
  return candidates[0] ?? null;
}
